export const AicciGauge = ({ score, label }) => {
  const r = 36;
  const c = 2 * Math.PI * r;
  const pct = Math.min(score, 100) / 100;
  let color = "#ef4444";
  if (score >= 60) color = "#10b981";
  else if (score >= 40) color = "#f59e0b";

  return (
    <div className="flex flex-col items-center gap-1">
      <svg width="88" height="88" viewBox="0 0 88 88">
        <circle cx="44" cy="44" r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="6" />
        <circle
          cx="44"
          cy="44"
          r={r}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
          strokeLinecap="round"
          transform="rotate(-90 44 44)"
          style={{
            transition: "stroke-dashoffset 1.2s ease-out",
            filter: `drop-shadow(0 0 8px ${color}60)`,
          }}
        />
        <text x="44" y="44" textAnchor="middle" dominantBaseline="central"
          fill={color} fontSize="18" fontWeight="900">{score}</text>
      </svg>
      <span className="text-[10px] text-slate-400 font-medium truncate max-w-[80px]">{label}</span>
    </div>
  );
};

export default AicciGauge;
